import { useFormContext } from "react-hook-form"
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { RequiredMark } from "./required-mark"

interface FormSelectFieldProps {
  name: string
  label: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  className?: string
  children: React.ReactNode
  onChange?: (value: string) => void
}

export function FormSelectField({
  name,
  label,
  placeholder,
  required,
  disabled,
  className,
  children,
  onChange,
}: FormSelectFieldProps) {
  const { control } = useFormContext()

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel className="text-gray-200 text-sm font-semibold">
            {label}
            {required && <RequiredMark />}
          </FormLabel>
          <FormControl>
            <Select
              key={field.value}
              onValueChange={(value) => {
                field.onChange(value)
                onChange?.(value)
              }}
              value={field.value}
              disabled={disabled}
            >
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
              <SelectContent>{children}</SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}